import { LeftComponents } from "./left-components";
import { RightComponents } from "./right-components";

interface FiltersProps {
  setSearchSelectedValue: (value: string) => void;
  handleSearchSubmit: () => void;
  handleSearchSubmitAuto: (locationSearchValue?: string) => void;
  onFilterClick: () => void;
}

export const Filters = ({
  setSearchSelectedValue,
  handleSearchSubmit,
  handleSearchSubmitAuto,
  onFilterClick,
}: FiltersProps) => {
  return (
    <div className="flex items-center gap-2 w-full">
      <LeftComponents
        handleSearchSubmitAuto={handleSearchSubmitAuto}
        setSearchSelectedValue={setSearchSelectedValue}
      />

      <RightComponents
        handleSearchSubmit={handleSearchSubmit}
        onFilterClick={onFilterClick}
      />
    </div>
  );
};
